export const AppActionTypes = {
    TOGGLE_MENU_MOBILE: 'isMenuOpen',
    SET_MENU_IDS: 'menuIds',
    SET_MENU_WITH_FOCUS: 'menuWithFocus',
};
